declare var $: any;
//system
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

//third-party
import { createEvent, DateArray, EventAttributes } from 'ics';
import { v4 as uuidv4 } from 'uuid';

//services
import { LogService } from 'src/app/services/common/log.service';
import { StudioService } from 'src/app/services/studio.service';
import { UserService } from 'src/app/services/user.service';

//interfaces
import { SessionDetails, ClassMember } from 'src/app/models/studio/session-details';
import { CancelBookingRequest } from 'src/app/models/studio/class-booking';

//utils
import { Utils } from 'src/app/services/common/utils';
import { EnvironmentService } from 'src/app/services/environment.service';
import { FacilityService } from 'src/app/services/facility.service';

declare const google: any;

@Component({
  selector: 'app-cancel-reservation',
  templateUrl: './cancel-reservation.component.html',
  styleUrls: ['./cancel-reservation.component.scss']
})
export class CancelReservationComponent implements OnInit {
  address :string = '';
  directionUrl :string = '';
  sessionTiming :string = '';
  showSpots: boolean = true;
  @Input() public sessionDetails! : SessionDetails;
  @Input() public classMember! : ClassMember;
  @Output() passEntry: EventEmitter<boolean> = new EventEmitter();

  submitted:              boolean  = false;

  constructor(
    public activeModal: NgbActiveModal
    , private router: Router
    , private location: Location
    , private logService: LogService
    , private studioService: StudioService
    , private userService: UserService
    , private _environmentService: EnvironmentService
    , private facilityService: FacilityService
  ) 
  {
    
  }

  private async getSessionTimeZone(): Promise<string> {
    let locations: { Id: number; TimeZone?: string }[] = [];
    try {
      locations = await this.facilityService.getLocations();
    } catch {
      locations = [];
    }
    return Utils.resolveSessionTimeZoneFromLocations(
      this.sessionDetails?.Studio?.LocationId,
      locations,
      this._environmentService.getFacilityConfig()?.timezone
    );
  }

  async ngOnInit() {
    this.address = await this.getAddress();
    this.directionUrl = this.getDirectionUrl();

    const sessionTimeZone = await this.getSessionTimeZone();
    const display = Utils.formatSessionDisplayParts(
      this.sessionDetails.StartDate,
      this.sessionDetails.StartTime,
      this.sessionDetails.EndTime,
      sessionTimeZone
    );
    this.sessionTiming = display.timeZoneAbbr
      ? `${display.dayOfWeek}, ${display.month} ${display.dayOfMonth} at ${display.startTimeFull} ${display.timeZoneAbbr}`
      : `${display.dayOfWeek}, ${display.month} ${display.dayOfMonth} at ${display.startTimeFull}`;
    if(!this.sessionDetails.Class.ShowSpotSelection)
    {
      this.showSpots = false;
    }
  }

  closeModal() {
    this.passEntry.emit(false);
    this.activeModal.close(false);
  }

  cancelSpot() {
    this.logService.debug("cancelling class member id :" + this.classMember.Id);
    this.submitted = true;
    var member: any = this.userService.getMember();
    const cancelBookingRequest: CancelBookingRequest = {
      ClassMemberId: this.classMember.Id,
      StripeCustomerId: "", //@todo: add it from backend.
      StripeCardId: "", //@todo: add it from backend.
      ReceiptEmail: ""  //@todo: add it from backend.
    };

    this.studioService.cancelSpot(cancelBookingRequest).subscribe((data: void) => {
      this.logService.debug("You have successfully cancelled spot " + this.classMember.Spot);
      this.submitted = false;
      this.passEntry.emit(true);
      this.activeModal.close(true);
    });
  }

  getDirectionUrl(): string {
    return `https://www.google.com/maps/dir/?api=1&destination=${this._environmentService.getFacilityConfig().googleMap.latitude},${this._environmentService.getFacilityConfig().googleMap.longitude}`;
  }

  async generateICS() {
    const sessionTimeZone = await this.getSessionTimeZone();
    const { start, end } = Utils.combineSessionStartAndEnd(
      this.sessionDetails.StartDate,
      this.sessionDetails.StartTime,
      this.sessionDetails.EndTime,
      sessionTimeZone
    );
    const startDateTimeArray: DateArray = Utils.toIcsDateTimeParts(start);
    const endDateTimeArray: DateArray = Utils.toIcsDateTimeParts(end);

    const event: EventAttributes = {
      start: startDateTimeArray,
      startInputType: 'utc',
      end: endDateTimeArray,
      endInputType: 'utc',
      title: this.sessionDetails.Class.Name + " at " + this.sessionDetails.Studio.Name,
      description: this.sessionDetails.Class.Name + " at " + this.sessionDetails.Studio.Name,
      location: this.address,
      url: window.location.origin + this.router.url,
      status: 'CONFIRMED',
      organizer: {
        name: this.sessionDetails.InstructorName,
        email: this._environmentService.getFacilityConfig().supportEmail
      }
    };
    
    createEvent(event, (error, value) => {
      if (error) {
        this.logService.error(error);
        return;
      }
  
      const blob = new Blob([value], { type: 'text/calendar' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'df-event-' + uuidv4() + '.ics';
      link.click();
    });
  }
  
  
  

  async getAddress(): Promise<string> {
    var address : string = "";
    const geocoder = new google.maps.Geocoder();
    const latLng = new google.maps.LatLng(this._environmentService.getFacilityConfig().googleMap.latitude, this._environmentService.getFacilityConfig().googleMap.longitude);

    return new Promise<string>((resolve, reject) => {
      geocoder.geocode({ location: latLng }, (results: any, status: any) => {
        if (status === "OK") {
          if (results[0]) {
            const address = results[0].formatted_address.replace("Inside ", "");
            resolve(address);
          } else {
            this.logService.debug("Geocoder: No results found");
            reject("No results found");
          }
        } else {
          this.logService.debug("Geocoder failed due to: " + status);
          reject(status);
        }
      });
    });
  }
}
